<template>
  <v-card flat fluid fill-height class="mt-3 pt-3">
    <v-card-text class="text-center mt-3">
      <div>
        <div>
          <img style="width:200px" v-if="$vuetify.theme.dark" :src="assets('logos/bjjlink-2025-white.png')" />
          <img style="width:200px" v-else :src="assets('logos/bjjlink-2025-black.png')" />
        </div>
      </div>
      <div class="text-overline text-h5">
        Your are running version: <b>{{ appVersion }}</b>
      </div>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn :loading="loginOut" color="error" elevation="0" @click="logout()">
        CONFIRM LOGOUT
        <v-icon class="ml-1">mdi-logout</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
    </v-card-actions>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn outlined color="primary" elevation="0" @click="backToApp()">
        BACK TO APP
      </v-btn>
      <v-spacer></v-spacer>
    </v-card-actions>
  </v-card>
</template>
<script>
import { Environment } from "@/services/Environment";
export default {
  data() {
    return {
      appVersion: Environment.get("VUE_APP_VERSION"),
      loginOut: false
    };
  },
  created() {
  },
  methods: {
    backToApp() {
      window.location.href = "/secure/home";
    },
    logout() {
      this.loginOut = true;
      this.$store.dispatch("setToken", null);
      this.$store.dispatch("setUser", null);
      this.$store.dispatch("setInApp", false);
      this.$store.dispatch("setSelectedAcademy", null);
      this.$store.dispatch("setManagedAcademy", null);
      this.$store.dispatch("setStripeAccountId", null);
      this.$store.dispatch("setPermissions", []);
      this.$store.dispatch("setAdminPlusVersion", false);
      localStorage.removeItem('vuex');
      localStorage.removeItem('token');
      setTimeout(function () {
        window.location.replace("/login");
      }, 2000);
    }
  },
};
</script>

<style scoped></style>